import React from 'react';
import classnames from 'classnames';
import s from './Badge.scss';
const Badge = ({ badge, size = 24, type = 'normal', className })=>{
    var _assets, _assets_compositeKey, _assets1, _images;
    const { title: badgeTitle, description, stackCount, assets } = badge;
    let title = badgeTitle;
    if (description) {
        title += `: ${description}`;
    }
    if (stackCount) {
        title += ` (${stackCount})`;
    }
    const compositeKey = type === 'normal' ? 'normalComposite' : 'hugeComposite';
    const images = ((_assets = assets) === null || _assets === void 0 ? void 0 : _assets[compositeKey]) ? (_assets_compositeKey = assets[compositeKey]) === null || _assets_compositeKey === void 0 ? void 0 : _assets_compositeKey.map((i)=>i.imageUrl) : [
        (_assets1 = assets) === null || _assets1 === void 0 ? void 0 : _assets1[type]
    ];
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[`size-${size}`], className),
        title: title
    }, (_images = images) === null || _images === void 0 ? void 0 : _images.filter((i)=>i).map((image)=>/*#__PURE__*/ React.createElement("img", {
            key: image,
            src: image,
            className: s['image'],
            alt: title,
            loading: "lazy"
        })));
};
Badge.displayName = 'Badge';
export default Badge;
